import React from 'react';
import './support.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDonate,
  faGift,
  faHandsHelping,
  faShareAlt,
  faHandshake,
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
  faUsers,
  faLightbulb
} from '@fortawesome/free-solid-svg-icons';

const Support = () => {
  return (
    <div className="support-page">
      <br></br>

      {/* Support Options Section */}
      <section className="support-options-section" id="support-options">
        <div className="support-container">
          <div className="support-section-title">
            <h2>Ways to Support</h2>
            <p>Join our mission to empower women and transform communities</p>
          </div>
          <div className="support-grid">
            <div className="support-card">
              <div className="support-card-icon">
                <FontAwesomeIcon icon={faDonate} />
              </div>
              <h3>Financial Contributions</h3>
              <p>Support our programs and projects through donations. Every contribution helps us expand our reach and impact.</p>
              <a href="#contact" className="support-btn">Donate Now</a>
            </div>
            <div className="support-card">
              <div className="support-card-icon">
                <FontAwesomeIcon icon={faGift} />
              </div>
              <h3>In-kind Support</h3>
              <p>Provide resources such as books, clothing, entrepreneurial tools, or school supplies to support our initiatives.</p>
              <a href="#contact" className="support-btn">Offer Support</a>
            </div>
            <div className="support-card">
              <div className="support-card-icon">
                <FontAwesomeIcon icon={faHandsHelping} />
              </div>
              <h3>Volunteering</h3>
              <p>Share your expertise and time in our projects, seminars, and community initiatives. Your skills can make a difference.</p>
              <a href="#contact" className="support-btn">Volunteer</a>
            </div>
           
            <div className="support-card">
              <div className="support-card-icon">
                <FontAwesomeIcon icon={faHandshake} />
              </div>
              <h3>Partnerships</h3>
              <p>We welcome strategic collaborations with organizations and companies in implementing social and development projects.</p>
              <a href="#contact" className="support-btn">Partner With Us</a>
            </div>
            <div className="support-card">
              <div className="support-card-icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <h3>Mentorship</h3>
              <p>Become a mentor and guide women in their personal and professional development journeys.</p>
              <a href="#contact" className="support-btn">Become a Mentor</a>
            </div>
            <div className="support-card">
              <div className="support-card-icon">
                <FontAwesomeIcon icon={faLightbulb} />
              </div>
              <h3>Skill Sharing</h3>
              <p>Share your professional skills through workshops, training sessions, or online courses for our beneficiaries.</p>
              <a href="#contact" className="support-btn">Share Skills</a>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="support-impact-section">
        <div className="support-container">
          <div className="support-impact-content">
            <h3>Your Support Makes a Difference</h3>
            <p>With your support, we can continue to expand our efforts and transform the lives of more women in our community. Together, we can create a society where every woman and child has the opportunity to thrive and realize their full potential.</p>
            <p>Since our establishment, we have impacted over 500 lives, served 10+ communities, and implemented 25+ programs focused on education, health, economic empowerment, and rights advocacy.</p>
            <a href="#contact" className="support-btn support-btn-primary">Get Involved Today</a>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="support-contact-section" id="contact">
        <div className="support-container">
          <div className="support-section-title">
            <h2>Get In Touch</h2>
            <p>Reach out to us to discuss how you can support our mission</p>
          </div>
          <div className="support-contact-details">
            <div className="support-contact-item">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <h4>Location</h4>
              <p>Makulu, Dodoma, Tanzania</p>
            </div>
            <div className="support-contact-item">
              <FontAwesomeIcon icon={faPhone} />
              <h4>Phone</h4>
              <p>+255 689 729 148</p>
            </div>
            <div className="support-contact-item">
              <FontAwesomeIcon icon={faEnvelope} />
              <h4>Email</h4>
              <p><a href="mailto:itambuethamaniyakotz@gmail.com">itambuethamaniyakotz@gmail.com</a></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Support;